import { render, staticRenderFns } from "./ContactOverview.vue?vue&type=template&id=5199e9ae&scoped=true"
import script from "./ContactOverview.vue?vue&type=script&lang=js"
export * from "./ContactOverview.vue?vue&type=script&lang=js"
import style0 from "./ContactOverview.vue?vue&type=style&index=0&id=5199e9ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5199e9ae",
  null
  
)

export default component.exports